module.exports = __webpack_public_path__ + "static/media/slogan2.c69e77f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/EVisual/Players/slogan2.jpg
// module id = 314
// module chunks = 0